import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePingQuery } from "../redux/services/crmAPI";

const PrivatRouts = () => {

    // const authStatus = useSelector((state) => state.status.isAuthor)

    const getStatus = () => {
        return JSON.parse(localStorage.getItem('isLoged'))
    }

    return (
        getStatus() ? <Outlet /> : <Navigate to='/' replace />
    );
};

export default PrivatRouts;